import React from "react";
import { connect } from "react-redux";
import {
  Transition,
  Container,
  Segment,
  Grid,
  Menu,
  Confirm
} from "semantic-ui-react";
import AlumnoForm from "./shared/alumnos/AlumnoForm";
import IncidenciasAlumno from "./detalleAlumno/IncidenciasAlumno";
import ActividadesAlumno from "./detalleAlumno/ActividadesAlumno";
import { alumnosOps } from "../ducks/alumnos";
import { incidenciasOps } from "../ducks/incidencias";

class DetalleAlumno extends React.Component {
  state = {
    visible: false,
    nombreAlumno: null,
    showConfirmEliminar: false
  };

  componentDidMount() {
    this.setState({ visible: true });
    this.props.obtenerDetalleAlumno(this.props.match.params.idAlumno);
    this.props.obtenerIncidencias(this.props.match.params.idAlumno);
  }

  componentWillReceiveProps(nextProps, nextContext) {
    const { nombre, apellido1, apellido2 } = nextProps.detalleAlumno;
    this.setState({
      nombreAlumno: `${nombre} ${apellido1} ${apellido2}`
    });
  }

  componentWillUnmount() {
    this.props.resetIncidencias();
    this.props.detachIncidencias(this.props.match.params.id);
    this.props.resetDetalleAlumno();
  }

  cerrarIncidencia = id => {
    this.props.cerrarIncidencia(id, this.props.user);
  };

  guardarIncidencia = (id, texto) => {
    const { user } = this.props;
    this.props.guardarIncidencia({
      alumno: this.props.detalleAlumno,
      id,
      texto,
      user
    });
  };

  updateDataAlumno = values => this.props.updateDataAlumno(values);

  handleVolver = () => this.props.history.goBack();

  handleAddAlumno = () => this.props.history.push("/nuevo/alumno");

  handleEliminarAlumno = () => this.setState({ showConfirmEliminar: true });

  handleCancelEliminar = () => this.setState({ showConfirmEliminar: false });

  handleConfirmEliminar = () => {
    this.props.eliminarAlumno(this.props.detalleAlumno.id);
    this.props.history.goBack();
  };

  render() {
    return (
      <Transition.Group animation="scale" duration={250}>
        {this.state.visible && (
          <Container fluid>
            <Menu>
              <Menu.Item header content="Detalle del Alumno" />

              <Menu.Item
                content="Añadir Alumno"
                icon="add"
                onClick={this.handleAddAlumno}
              />
              <Menu.Item
                content="Eliminar Alumno"
                icon="trash"
                onClick={this.handleEliminarAlumno}
              />

              <Menu.Menu position="right">
                <Menu.Item
                  content="Cerrar"
                  icon="cancel"
                  onClick={this.handleVolver}
                />
              </Menu.Menu>
            </Menu>

            <Segment basic>
              <Grid columns={3}>
                <Grid.Column width={4}>
                  <ActividadesAlumno />
                </Grid.Column>
                <Grid.Column width={8}>
                  <AlumnoForm
                    initialValues={this.props.detalleAlumno}
                    action={this.updateDataAlumno}
                  />
                </Grid.Column>
                <Grid.Column width={4}>
                  <IncidenciasAlumno
                    incidencias={this.props.incidencias}
                    cerrarIncidencia={this.cerrarIncidencia}
                    guardarIncidencia={this.guardarIncidencia}
                    nombreAlumno={this.state.nombreAlumno}
                  />
                </Grid.Column>
              </Grid>
            </Segment>

            <Confirm
              open={this.state.showConfirmEliminar}
              header="Eliminar Alumno"
              content="Esto eliminará al alumno de la base de datos. ¿Desea continuar?"
              onCancel={this.handleCancelEliminar}
              onConfirm={this.handleConfirmEliminar}
              closeOnDimmerClick={false}
              cancelButton="Cancelar"
              confirmButton="Eliminar"
            />
          </Container>
        )}
      </Transition.Group>
    );
  }
}

const mapStateToProps = state => ({
  detalleAlumno: state.alumnos.detalleAlumno,
  incidencias: state.incidencias.incidencias,
  user: state.session.user
});

const actions = {
  obtenerIncidencias: incidenciasOps.obtenerIncidencias,
  resetIncidencias: incidenciasOps.resetIncidencias,
  detachIncidencias: incidenciasOps.detachIncidencias,
  cerrarIncidencia: incidenciasOps.cerrarIncidencia,
  guardarIncidencia: incidenciasOps.guardarIncidencia,
  eliminarAlumno: alumnosOps.eliminarAlumno,
  obtenerDetalleAlumno: alumnosOps.obtenerDetalleAlumno,
  resetDetalleAlumno: alumnosOps.resetDetalleAlumno,
  updateDataAlumno: alumnosOps.updateDataAlumno
};

export default connect(mapStateToProps, actions)(DetalleAlumno);



// WEBPACK FOOTER //
// ./src/pages/DetalleAlumno.jsx